import React from 'react';
import { Row, Col, Carousel } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import surveyIllustration from '../../assets/img/homepage/survey_illustration3.png';
import barChartIllustration from '../../assets/img/homepage/bar_chart_illustration.png';
import lineImproveOverTime from '../../assets/img/homepage/improve over time.png';
import styled, { css } from 'styled-components';
import { FaChartLine, FaDollarSign, FaEye } from 'react-icons/fa';
import { FaPoll, FaChartBar, FaExpandArrowsAlt, FaPuzzlePiece } from 'react-icons/fa';
import PayPal from '../../shared/components/payments/paypal';




const Section = styled.div`
  padding: 60px 10%; /* Adding horizontal padding */
  text-align: center;

  > div {
    display: flex;
  }
`;

const FeatureImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 15px; // Reduced space
  max-width: 400px; // Default max width
  ${props => props.isMiddleImage && css`
    max-width: 550px;
    min-width: 550px; // Wider for the middle image
  `}

`;


const Title = styled.h2`
  margin-bottom: 30px;
`;

const StepDescription = styled.p`
  font-size: 16px;
  margin: 0 0 20px 0;
  max-width: 400px;
  @media (max-width: 768px) {
    max-width: 95%;
  }
  font-weight: 900;
`;

const DetailedParagraph = styled.p`
  max-width: 400px; /* Adjusted for consistency */
  margin: 20px auto;
  @media (max-width: 768px) {
    max-width: 95%;
  }
`;

const CellContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  height: 100%;
`;

const FeatureItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-10px);
  }

  svg {
    margin-bottom: 15px;
    font-size: 48px; /* Adjust icon size here */
    color: #007bff; /* Example color, adjust as needed */
  }
`;

const FeatureText = styled(DetailedParagraph)` // Assuming DetailedParagraph is already styled
  font-size: 18px;
  font-weight: bold;
  margin-top: 10px;
`;

class HomePage extends React.Component {
  constructor(props) {
    super(props);
  }



  render() {
    return (
      <>

        <Section>
          <Title>How It Works</Title>
          <Row>
            <Col md={4}>
              <CellContainer>
                <StepDescription>Upload Your Survey Answers</StepDescription>
                <FeatureImage src={surveyIllustration} alt='Upload' />
                <DetailedParagraph>Start by simply uploading the answers from your customer feedback surveys. Our
                  platform is designed to handle a variety of formats, making it easy for you to
                  begin.</DetailedParagraph>

              </CellContainer>
            </Col>
            <Col md={4}>
              <CellContainer>
                <StepDescription>Receive Instant Reports</StepDescription>
                <FeatureImage isMiddleImage src={barChartIllustration} alt='Analyze' />
                <DetailedParagraph>Our advanced algorithms analyze your data to provide actionable insights and visual
                  reports. Watch as complex data becomes understandable insights.</DetailedParagraph>

              </CellContainer>
            </Col>
            <Col md={4}>
              <CellContainer>
                <StepDescription>Implement & Improve</StepDescription>
                <FeatureImage src={lineImproveOverTime} alt='Improve' />
                <DetailedParagraph>Use the detailed reports to make informed decisions. Our insights aim to help you
                  effectively improve customer satisfaction and drive growth.</DetailedParagraph>

              </CellContainer>
            </Col>
          </Row>

        </Section>

        <Section>
  <Title>Advantages</Title>
  <Row>
    <Col md={4} className="d-flex align-items-stretch">
      <CellContainer>
        <FaChartLine size={50} style={{ alignSelf: 'center', marginBottom: '20px' }} />
        <StepDescription>Immediate Insights</StepDescription>
        <DetailedParagraph>Gain immediate access to your reports, allowing for quick decision-making and implementation.</DetailedParagraph>
      </CellContainer>
    </Col>
    <Col md={4} className="d-flex align-items-stretch">
      <CellContainer>
        <FaDollarSign size={50} style={{ alignSelf: 'center', marginBottom: '20px' }} />
        <StepDescription>Unbeatable Price</StepDescription>
        <DetailedParagraph>Our competitive pricing model offers a free tier for initial users and an affordable plan for larger data sets, making high-quality insights accessible to all.</DetailedParagraph>
      </CellContainer>
    </Col>
    <Col md={4} className="d-flex align-items-stretch">
      <CellContainer>
        <FaEye size={50} style={{ alignSelf: 'center', marginBottom: '20px' }} />
        <StepDescription>Visual Proof</StepDescription>
        <DetailedParagraph>Our reports include visual data representations, making complex information digestible and easy to share with stakeholders.</DetailedParagraph>
      </CellContainer>
    </Col>
  </Row>
</Section>

        <Section>
  <Title>Main Features</Title>
  <Row>
    <Col md={3}>
      <FeatureItem>
        <FaPoll />
        <FeatureText>Survey Analysis</FeatureText>
      </FeatureItem>
    </Col>
    <Col md={3}>
      <FeatureItem>
        <FaChartBar />
        <FeatureText>Visual Reports</FeatureText>
      </FeatureItem>
    </Col>
    <Col md={3}>
      <FeatureItem>
        <FaExpandArrowsAlt />
        <FeatureText>Scalable Solutions</FeatureText>
      </FeatureItem>
    </Col>
    <Col md={3}>
      <FeatureItem>
        <FaPuzzlePiece />
        <FeatureText>Integration Ready</FeatureText>
      </FeatureItem>
    </Col>
  </Row>
</Section>

        <Section>
          <Title>Testimonials</Title>
          <Carousel>
            <Carousel.Item>
              <p>"This tool radically transformed our understanding of customer feedback. Highly recommend!"</p>
              <em>- Alex, Product Manager</em>
            </Carousel.Item>
            <Carousel.Item>
              <p>"Thanks to this analytics tool, we've seen a 50% increase in customer satisfaction."</p>
              <em>- Jordan, Customer Success Lead</em>
            </Carousel.Item>
          </Carousel>
        </Section>
      </>
    );
  }
}

export default withRouter(HomePage);